function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "menu-capability",
  "data-name": "Path 3486",
  d: "M13.1,4.177l1.827,3.651a1.228,1.228,0,0,0,.926.664l4.088.588a1.21,1.21,0,0,1,.681,2.071l-2.956,2.84a1.2,1.2,0,0,0-.354,1.075l.7,4.01a1.228,1.228,0,0,1-1.787,1.28l-3.654-1.895a1.248,1.248,0,0,0-1.146,0L7.773,20.357a1.227,1.227,0,0,1-1.786-1.28l.7-4.01a1.2,1.2,0,0,0-.354-1.075l-2.956-2.84a1.21,1.21,0,0,1,.681-2.071l4.088-.588a1.23,1.23,0,0,0,.927-.664L10.9,4.177A1.239,1.239,0,0,1,13.1,4.177Z",
  transform: "translate(-2.233 -2.75)",
  fill: "none",
  stroke: "#505e6c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  fillRule: "evenodd"
});

function SvgMenuCapability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.533,
    height: 18.522,
    viewBox: "0 0 19.533 18.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCapability);
export default __webpack_public_path__ + "static/media/menu-capability.2e3e37ec.svg";
export { ForwardRef as ReactComponent };